import { render, staticRenderFns } from "./NRWbauantrag64_2022.vue?vue&type=template&id=67afe5b4&"
import script from "./NRWbauantrag64_2022.vue?vue&type=script&lang=js&"
export * from "./NRWbauantrag64_2022.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports